// A drawer opened without a `Dialog.Trigger` has nothing for Radix to refocus on close, so it falls
// back to `<body>`. The opener is passed in rather than read from `document.activeElement`, because
// `DefaultButton` and `GhostButton` cancel mousedown and a clicked card button never takes focus.
// Radix fires this after the drawer is gone, so focus that has already moved on — into a drawer that
// replaced this one — is left where it is.
export const returnFocusOnClose = (opener: HTMLElement | undefined) => (event: Event) => {
  const isFocusUnclaimed = !document.activeElement || document.activeElement === document.body
  if (opener?.isConnected && isFocusUnclaimed) {
    event.preventDefault()
    opener.focus()
  }
}
